import { Component, JSX, h, Host, ComponentInterface } from '@stencil/core';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { ProductCategory } from 'app/shared/models/product-category.model';
import { store } from 'app/shared/store/store';

@Component({
  tag: 'features-highlight',
  styleUrl: 'features-highlight.scss'
})
export class FeaturesHighlight implements ComponentInterface {
  private productCategory: ProductCategory = store.get(StoreKeys.productCategory);
  public render(): JSX.Element {
    let elementToRender: HTMLElement;
    switch (this.productCategory) {
      case 'nbn':
        elementToRender = <nbn-features-highlight />;
    }

    return <Host>{elementToRender}</Host>;
  }
}
